import { render } from "./DetailTicketManagerView.vue?vue&type=template&id=69d0b101"
import script from "./DetailTicketManagerView.vue?vue&type=script&lang=js"
export * from "./DetailTicketManagerView.vue?vue&type=script&lang=js"

import "./DetailTicketManagerView.vue?vue&type=style&index=0&id=69d0b101&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__